/* FDA 24 Sep 2026 (audit R01): with no "widget parent selector" set, Appstle writes the chosen subscription price into
   every .price-item--regular on the page, so the Related products cards showed the main product's price ($11.70 and
   SAVE 10% on a $19.95 bag). Appstle's admin has no field for it, so the theme sets it: Appstle then only touches the
   price inside the product info column that holds its widget.

   Timing: this is a deferred script in <head>. Deferred scripts run in document order after the page is parsed, so it
   runs after Appstle's inline config (end of <body>, sets RS.Config and _RSConfig) and before Appstle's own deferred
   script, which merges _RSConfig into RS.Config and copies it to window.RSConfig. */
(function () {
  var SCOPE = '.product__info-container';
  try {
    window.RS = window.RS || {};
    window.RS.Config = window.RS.Config || {};
    if (!window.RS.Config.widgetParentSelector) window.RS.Config.widgetParentSelector = SCOPE;
    if (typeof window._RSConfig === 'object' && window._RSConfig && !window._RSConfig.widgetParentSelector) {
      window._RSConfig.widgetParentSelector = SCOPE;
    }
  } catch (e) {}
})();
